import Vue from "vue"
import Buefy from "buefy"
import BasicHero from "./App.vue"



Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(BasicHero)


if(document.getElementById("basicHeroApp")){
    new Vue({
        render: h=>h(
            BasicHero,{
                props:{
                    dataUrl:document.getElementById("basicHeroApp")
                        .getAttribute("dataUrl"),
                    primaryColor:document.getElementById("basicHeroApp")
                        .getAttribute("primary-color"),
                    blackText:document.getElementById("basicHeroApp")
                        .getAttribute("black-text"),
                }
            }
        )
    }).$mount("#basicHeroApp")
}